var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "customer-groups-picker" }, [
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "m-5" },
          [
            _c(
              "a-table",
              {
                key: "vtable-" + _vm.renderCount,
                attrs: {
                  rowKey: "_id",
                  columns: _vm.columns,
                  dataSource: _vm.customerGroups,
                  pagination: {
                    pageSize: 5,
                    showSizeChanger: true,
                    showQuickJumper: true,
                  },
                  customRow: function (record) {
                    return {
                      props: {},
                      on: {
                        click: function (event) {
                          _vm.rowClicked(record)
                        },
                      },
                    }
                  },
                  rowClassName: _vm.getRowClassName,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "index",
                      fn: function (text, record) {
                        return [
                          _vm.selectedRowId === record._id
                            ? _c(
                                "span",
                                {
                                  staticClass: "text-success",
                                  staticStyle: { "font-size": "16px" },
                                },
                                [_c("a-icon", { attrs: { type: "check" } })],
                                1
                              )
                            : _c("span", [_vm._v(_vm._s(text))]),
                        ]
                      },
                    },
                    {
                      key: "avatar",
                      fn: function (text, record) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "customer-group-avatar text-center",
                              class: {
                                "customer-group-avatar-odd":
                                  record.index % 2 === 0,
                              },
                            },
                            [
                              _c(
                                "md-highlight-text",
                                {
                                  staticClass: "text-center",
                                  attrs: { "md-term": "term" },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        record.name.slice(0, 2).toUpperCase()
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "contacts",
                      fn: function (text, record) {
                        return _c("span", {}, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$_.get(record, "contacts.length", 0)
                                  ? _vm.$_.get(record, "contacts.length", 0) +
                                      " Contact"
                                  : _vm.$t("wp.noContactFound")
                              )
                          ),
                        ])
                      },
                    },
                    {
                      key: "description",
                      fn: function (text, record) {
                        return _c("span", {}, [
                          _vm._v(
                            _vm._s(_vm.$_.get(record, "description", "-"))
                          ),
                        ])
                      },
                    },
                  ],
                  null,
                  false,
                  693400886
                ),
              },
              [
                _c(
                  "span",
                  { attrs: { slot: "indexTitle" }, slot: "indexTitle" },
                  [_vm._v(" # ")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { attrs: { slot: "nameTitle" }, slot: "nameTitle" },
                  [_vm._v(" " + _vm._s(_vm.$t("wp.name")) + " ")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    attrs: { slot: "descriptionTitle" },
                    slot: "descriptionTitle",
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("wp.description")))]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { attrs: { slot: "contactsTitle" }, slot: "contactsTitle" },
                  [_vm._v(" " + _vm._s(_vm.$t("wp.contacts")))]
                ),
              ]
            ),
          ],
          1
        )
      : _c("div", [_c("a-spin")], 1),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }